:host {
  display: block;
}
.landing-faq-heading-text {
  font-family: var(--typography-font-landing-base-heading);
  color: var(--clrs-landing-font-heading);
}
.landing-faq-sub-heading-text {
  font-family: var(--typography-font-landing-base-body);
  color: var(--clrs-landing-font-heading);
}
.landing-faq-base-text {
  font-family: var(--typography-font-landing-base-heading);
  color: var(--clrs-landing-font-body);
}
